// Anexos: cifrados no aparelho com AES-256-GCM (WebCrypto) e chave aleatória por arquivo; a chave viaja dentro da mensagem Signal.
const b64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
const unb64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));

export async function encryptFile(file) {
  const raw = await file.arrayBuffer();
  const key = await crypto.subtle.generateKey({ name: "AES-GCM", length: 256 }, true, ["encrypt"]);
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const cipher = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, raw);
  const digest = b64(await crypto.subtle.digest("SHA-256", raw));
  return { cipher: new Blob([cipher]), key: b64(await crypto.subtle.exportKey("raw", key)), iv: b64(iv), digest, name: file.name, mime: file.type || "application/octet-stream", size: raw.byteLength };
}

export async function decryptFile(cipherBuf, att) {
  const key = await crypto.subtle.importKey("raw", unb64(att.key), { name: "AES-GCM" }, false, ["decrypt"]);
  const raw = await crypto.subtle.decrypt({ name: "AES-GCM", iv: unb64(att.iv) }, key, cipherBuf);
  if (b64(await crypto.subtle.digest("SHA-256", raw)) !== att.digest) throw new Error("Anexo corrompido ou adulterado.");
  return new Blob([raw], { type: att.mime });
}
